import LocationOnIcon from '@mui/icons-material/LocationOn';

import React from 'react';
import { IconWithText } from './components';
import { ILocation } from '../../../interfaces/common/location';
import { ShopLocationType } from '../../../interfaces/delivery-company/pickups';
import { displayLocation } from '../../../utils/locations';

interface AddressWithIconProps {
    address: ILocation | ShopLocationType | null;
}

function AddressWithIcon({ address }: AddressWithIconProps) {
    return (
        <IconWithText><LocationOnIcon color='primary' /> {address == null ? "No Location" : displayLocation(address)}</IconWithText>
    );
}

export default AddressWithIcon;